import React from "react";
import PropTypes from "prop-types";

import {CustomInput} from "../../components"


import {
    withStyles,
    Select,
    FormControl,
    InputLabel,
    MenuItem
} from "@material-ui/core";

class ImageQuestion extends React.Component{

        state={
            textAnswerType:"short"
        }

        componentDidMount(){
            const {isShortAnswer} = this.props
            if(isShortAnswer){
                this.setState({textAnswerType:"short"})
            }
            else{
                this.setState({textAnswerType:"long"})
            }

        }


        handleChange = event => {
            this.setState({ textAnswerType: event.target.value });
            const {onTypeChange} = this.props

            if(onTypeChange){



                onTypeChange(event.target.value==="short")
            }
        };

       render(){
        const {inputProps,key,classes,disabled} = this.props;

        const {textAnswerType} = this.state

        return(<div style={{paddingTop:30}} className={classes.root}>
                <div className={classes.controls}>
                    <FormControl className={classes.formControl}>
                        <InputLabel  shrink={true} htmlFor={`answerType-${key}`}>Answer Type</InputLabel>
                        <Select
                            disabled={disabled}
                            value={textAnswerType}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'answerType',
                                id: `answerType-${key+1}`,
                            }}
                        >
                            <MenuItem value={"short"}>Short Answer</MenuItem>
                            <MenuItem value={"long"}>Long Answer</MenuItem>
                        </Select>
                    </FormControl>
                </div>

            <CustomInput
                disabled={disabled}
                labelText="Question Prompt"
                formControlProps={{
                    fullWidth: true
                }}
                inputProps={inputProps}

            />
                {disabled?<CustomInput
                    labelText={textAnswerType==="short"?"Short answer shows here":"Long answer shows here"}
                    formControlProps={{
                        fullWidth: true,
                        disabled:true
                    }}

                />
                :
                <div/>
                }
        </div>
       )
        }
}

const styles={
    formControl: {
        minWidth: 120,
    },
    root:{
        width:"100%"
    },
    controls:{
        display:"flex",
        flexDirection:"row",
        justifyContent:"space-between"
    },
    iconButton:{

    }

}


export default withStyles(styles)(ImageQuestion);


// WEBPACK FOOTER //
// ./src/components/QuestionTypes/ImageQuestion.jsx